import { Directive } from '@angular/core';


@Directive({
    selector: '[mcSuffix]'
})
export class McSuffix {}
